import type { ContentEntity } from "shared/schema";
import { ReactButton } from "./ReactButton.js";
import { ReactionCount } from "./ReactionCount.js";

export function ReactionSummary({ count, target, mods = "" }: { count: number; target: ContentEntity; mods?: string | undefined }): React.ReactElement {
	return (
		<div className={`flex-row gap-none ${mods}`}>
			<ReactionCount count={count} target={target} />
			<ReactButton target={target} />
		</div>
	);
}
